import classnames from 'classnames';

import ZpButton from 'components/zpButton';

import classes from './index.module.css';

export const LogOutButton = ({ onClick, className }) => (
  <ZpButton
    id="auth-logout"
    theme="primary"
    size="big"
    type="button"
    className={classnames('custom-btn z-p-0 z-font-14 text-uppercase', classes.signBtn, classes.logOut, className)}
    onClick={onClick}
    isFullWidth={className?.includes('w-100')}
  >
    Log Out
  </ZpButton>
)

export const SignInButton = ({ onSignIn, className }) => (
  <ZpButton
    theme="primary"
    size="big"
    type="button"
    className={classnames('custom-btn z-p-0 z-font-14 text-uppercase', classes.signBtn, classes.signIn, className)}
    onClick={onSignIn}
    isFullWidth={className?.includes('w-100')}
  >
    Sign In
  </ZpButton>
);

export const AuthMenu = ({ onSignIn, showMobile = false }) => (
  <div
    className={classnames('flex-column flex-lg-row align-items-center', {
      'd-none d-lg-flex': !showMobile,
      'd-flex': showMobile,
    })}
  >
    <SignInButton onSignIn={onSignIn} className={showMobile ? 'w-100' : ''} />
  </div>
);
